import React from 'react';
import PropTypes from 'prop-types';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { MLModalService } from 'ml-portals-services-react';
import { platformMessages } from 'ml-components-platform-react';
import metadata from './MLReplacementCostSummaryPrintButtonComponent.metadata.json5';
import messages from './MLReplacementCostSummaryPrintButtonComponent.messages';

function MLReplacementCostSummaryPrintButtonComponent(props) {
    const { authHeader } = useAuthentication();
    const {
        constructionDetailsVM,
        jobId,
        sessionId,
        isPolicyChange
    } = props;
    const { 
        showErrorModal,
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const displayErrorModal = () => {
        showErrorModal(messages.documentError, messages.downloadDocError);
    };

    const onClickReplacementCostSummaryPrintButton = async() => {
        const valuationID = constructionDetailsVM.valuationID.value;
        const valuationVersion = constructionDetailsVM.valuationVersion.value;

        showProgressDialog(platformMessages.downloadingDocument);
        const fileName = `360Value Replacement Cost Valuation ${valuationID}.${valuationVersion}.pdf`;
        const appendToUrl = `${jobId}?valuationID=${valuationID}&valuationVersion=${valuationVersion}&token=${sessionId}&fileName=${encodeURIComponent(fileName)}`;
        await GatewayDocumentService.downloadDocumentPreview(appendToUrl, authHeader, displayErrorModal, isPolicyChange);
        hideProgressDialog();
    };

    const overrideProps = {
        replacementCostSummaryPrintButton: {
            onClick: onClickReplacementCostSummaryPrintButton
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={constructionDetailsVM}
            overrideProps={overrideProps}
        />
    );
}

MLReplacementCostSummaryPrintButtonComponent.propTypes = {
    constructionDetailsVM: PropTypes.shape({}).isRequired,
    jobId: PropTypes.string.isRequired,
    sessionId: PropTypes.string.isRequired,
    isPolicyChange: PropTypes.bool
};

MLReplacementCostSummaryPrintButtonComponent.defaultProps = {
    isPolicyChange: false
}

export default MLReplacementCostSummaryPrintButtonComponent;
